import { Lightning } from "@lightningjs/sdk";
import { List } from "@lightningjs/ui";
import theme from "../../../../lib/theme";
import { MENU_WIDTH } from "../../../../lib/utils";
import { CategoryItem, CATEGORY_ITEM_H, CATEGORY_ITEM_W } from "../CategoryItem/CategoryItem";

interface CategoryListSpec extends Lightning.Component.TemplateSpec {
    List: typeof List;
}

export class CategoryList
    extends Lightning.Component<CategoryListSpec>
    implements Lightning.Component.ImplementTemplateSpec<CategoryListSpec>
{
    static override _template(): Lightning.Component.Template<CategoryListSpec> {
        return {
            w: theme.layout.w - MENU_WIDTH - 28,
            h: CATEGORY_ITEM_H,
            clipping: true,
            List: {
                type: List,
                direction: "row",
                spacing: 20,
                w: theme.layout.w - MENU_WIDTH - 28,
                h: CATEGORY_ITEM_H,
                scroll: { after: 5 },
                scrollTransition: {
                    duration: 0.3,
                    timingFunction: "cubic-bezier(0.4, 0, 0.2, 1)"
                }
            }
        };
    }

    private get _list(): List {
        return this.getByRef("List") as unknown as List;
    }

    override _getFocused(): Lightning.Component | null | undefined {
        return this.getByRef("List") as Lightning.Component;
    }

    setGroups(names: string[]) {
        const list = this._list as any;
        list.reload(
            names.map((name) => ({
                type: CategoryItem,
                w: CATEGORY_ITEM_W,
                h: CATEGORY_ITEM_H,
                item: { name }
            }))
        );
        list.setIndex(0);
    }

    setSelectedCategory(name: string) {
        const list = this._list as any;
        const items: CategoryItem[] = list.items ?? [];
        const index = items.findIndex((item) => item.name === name || item.item?.name === name);
        items.forEach((item) => {
            item.selected = item.name === name;
        });
        if (index >= 0) {
            list.setIndex(index);
        }
    }

    get index(): number {
        return (this._list as any).index ?? 0;
    }

    scrollToFirst() {
        (this._list as any).setIndex(0);
    }

    override _handleDown() {
        return false;
    }

    override _handleUp() {
        return false;
    }
}
